namespace Solovis.InvDataSelectors {

    export class ExposureProfileSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public selectionCallback;
        public settings;
        public selectedExposureProfile;

        public _filterListControl;
        public jsonModelEnv;
        public profileList;

        public _availableHeight;


        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;

            this.settings = options.settings ? options.settings : {};
            this.selectedExposureProfile = options.initialValue ? options.initialValue : null;
        }


        public doInitAsync() {
            var self = this;
            this._portalServices.rpc().invoke("~/Selectors/ExposureProfileSelector/GetProfiles", {},
                function (response, success) {
                    if (success) {
                        self.jsonModelEnv = response.result.modelEnvironment;

                        var profileList = [];
                        $(self.jsonModelEnv.exposureProfiles).each(function (i, profile) {
                            profileList.push(profile);
                        });

                        self.profileList = profileList;
                    }

                    self.notifyInitComplete();
                });
        }


        public doRender() {
            var self = this;

            var selectorControlHostDiv = $("<div>")
                .addClass("solovis-input")
                .appendTo(this.container);

            var exposureProfileFilter = function (itemList, filterOptions) {
                var resultList = [];

                var queryTextLower = filterOptions.queryText.toLowerCase();
                $(itemList).each(function (index, item: any) {

                    var labelMatch = -1;

                    var itemLabelLower = "";
                    if (item.label) {
                        itemLabelLower = item.label.toLowerCase();
                        labelMatch = itemLabelLower.indexOf(queryTextLower);
                    }

                    if (labelMatch !== -1) {

                        resultList.push({
                            item: item,
                            labelLower: itemLabelLower
                        });
                    }
                });

                function compare(a, b) {
                    if (a.labelLower < b.labelLower) {
                        return -1;
                    }
                    else if (a.labelLower > b.labelLower) {
                        return 1;
                    }

                    return 0;
                }

                return resultList.sort(compare);
            }

            var exposureProfileItemDivGenerator = function (itemHolder, filterOptions) {
                var itemDiv = $("<div>")
                    .text(itemHolder.item.label);

                var isSelectedItem = false;
                var selectedItem = self.selectedExposureProfile;
                if (selectedItem) {
                    isSelectedItem = true;
                    for (var property in selectedItem) {
                        if (selectedItem.hasOwnProperty(property)) {

                            if (property === "tagSetIds") {
                                if (_.difference(selectedItem[property], itemHolder.item[property]).length !== 0) {
                                    isSelectedItem = false;
                                }
                            }

                            else if (selectedItem[property] !== itemHolder.item[property]) {
                                isSelectedItem = false;
                            }
                        }
                    }
                }

                if (isSelectedItem) {
                    itemDiv.addClass("active");
                }

                return itemDiv;
            }

            this._filterListControl = new Solovis.UI.StringFilterListControl({
                controlHost: selectorControlHostDiv,
                listItems: this.profileList,
                listFilter: exposureProfileFilter,
                itemDivGenerator: exposureProfileItemDivGenerator,
                selectedItem: self.selectedExposureProfile
            });

            $(this._filterListControl)
                .on("selectionChanged", function () {
                    var selectedItem = self._filterListControl.getSelectedItem();
                    self.selectionCallback(selectedItem);
                });

            this._filterListControl.setAsCurrentControl();

            self._filterListControl.focusFilter();

            if (self._availableHeight) {
                this._filterListControl.setAvailableHeight(self._availableHeight);
                self._availableHeight = null;
            }
            self._filterListControl.scrollToSelectedItem();

        }


        public setAvailableHeight(overallHeight) {
            var self = this;
            if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
                this._filterListControl.setAvailableHeight(overallHeight);
            }
            else {
                // The control is still rendering, so we will store the overallHeight and defer until the render is complete
                this._availableHeight = overallHeight;
            }
        }

    }

}